var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loggedIn)?_c('ConsentScreen',{attrs:{"valid-fed-id":_vm.validFederatedId,"federated-id":_vm.federatedId}}):_c('Login',{attrs:{"valid-fed-id":_vm.validFederatedId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }